export const importWrappersModuleFederation = {
  kbase: {
    key: 'remoteKbase/KBaseLoaderWrapper',
    importFn: () => import('remoteKbase/KBaseLoaderWrapper'),
  },
  docflow: {
    key: 'remoteDocflow/DebuggerLoaderWrapper',
    importFn: () => import('remoteDocflow/DebuggerLoaderWrapper'),
  },
  amplify: {
    key: 'amplifyImpact/AmplifyImpactInjector',
    importFn: () => import('amplifyImpact/AmplifyImpactInjector'),
  },
}
